import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import imagen1 from '../img/get_view1.jpg'; 
import Sidebar from '../componenteExtra/SidebarseniorGET';
import { FaClock, FaClipboardCheck } from 'react-icons/fa';
import Footer from '../componenteExtra/Footer';
import NotificationBellSeniorGET from '../notificaciones/NotificationBellSeniorGET';
import SessionManager from '../componenteExtra/SessionManager';

const MenuSeniorGET = () => {
    const navigate = useNavigate();
    const [nombre, setNombre] = useState('');
    const [grupo, setGrupo] = useState('');

    useEffect(() => {
        // Obtener el nombre y grupo del localStorage
        const storedNombre = localStorage.getItem('nombre_get');
        const storedGrupo = localStorage.getItem('grupo');
        if (storedNombre) setNombre(storedNombre);
        if (storedGrupo) setGrupo(storedGrupo);
    }, []);

    return (
        <div className="app">
            <SessionManager />
            <div className="main-content">
                <Sidebar />
                <div className="main-panel">
                    <div className="welcome-message">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "20px 0",
                                width: "100%",
                                marginBottom: "10px",
                            }}
                        >
                            <h2 style={{ margin: 0, lineHeight: 1 }}>
                                Bienvenido(a) Senior - {nombre}
                            </h2>
                            {nombre && <NotificationBellSeniorGET />}
                        </div>
                        <img src={imagen1} alt="Decorative" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <div className="cards-container">
                        <div className="card">
                            <div className="card-header">
                                <FaClock />
                                <h3>Solicitudes por aprobar</h3>
                            </div>
                            <div className="card-subtitle">Acceso directo</div>
                            <div className="card-content">
                                Este módulo se verán las solicitudes recibidas en espera de la aprobación.
                            </div>
                            <button onClick={() => navigate('/RevisarActividadesSeniorGET')}>
                                Ir a solicitudes por aprobar
                            </button>
                        </div>
                        <div className="card">
                            <div className="card-header">
                                <FaClipboardCheck />
                                <h3>Solicitudes completadas</h3>
                            </div>
                            <div className="card-subtitle">Acceso directo</div>
                            <div className="card-content">
                                Este módulo se verán las solicitudes de actividades completadas por GET.
                            </div>
                            <button onClick={() => navigate('/SolicitudesCompletadasSeniorGET')}>
                                Ir a Asignar Actividades
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MenuSeniorGET;